import ApiService from "../core/services/api.service";
import store from "../core/services/store";

export default {

  getUserPharmaciesInfo() {
    return ApiService.get("ph/v1/Users/GetUserPharmaciesInfo")
  },
  getUserInfo() {
    return ApiService.get("ph/v1/Users/GetUserInfo")
  },
  getUserRoles() {
    return ApiService.get("v1/Users/userroles")
  },
  hasRoles(roles) {
    var currentUser = store.getters["currentUser"];
    for (let i = 0; i < roles.length; i++) {
      const role1 = roles[i];
      if (currentUser.roles) {
        for (let j = 0; j < currentUser.roles.length; j++) {
          const role2 = currentUser.roles[j];
          if (role1 == role2) return true;
        }
      }
    }
    return false;
  }

  

}
